import React from "react";
import { MouseEventHandler } from "react";

import { Box, Button, Typography, useTheme } from "@mui/material";

import AddIcon from "@mui/icons-material/Add";

import Menu, { MenuProps } from "../Menu/Menu";

export type Workspace = {
  name: string;
  description: string;
  selected?: boolean;
  onWorkspaceClick: MouseEventHandler | undefined;
};
export type WorkspaceMenuProps = MenuProps & {
  workspaces: Workspace[];
  onAddWorkspaceClick: MouseEventHandler | undefined;
};

const WorkspaceMenu = ({ workspaces, onAddWorkspaceClick, ...others }: WorkspaceMenuProps) => {
  const theme = useTheme();
  return (
    <>
      <Menu
        {...others}
        buttonSx={{
          fontSize: "0.8125rem",
          fontWeight: 500,
          maxWidth: { xs: 200, sm: 300 },
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
        sx={{
          "& .MuiPaper-root": {
            minWidth: 300,
            maxWidth: "min(400px, calc(100vw - 24px))",
            marginTop: "35px",
            borderRadius: "8px",
            overflow: "hidden",
            left: {
              xxl: "calc(100% - (100% - 1720px) - 350px)!important",
              xs: "calc(100% - 350px)!important",
            },
          },
          "& .MuiMenu-list": {
            border: 0,
          },
          "& .MuiButtonBase-root": {
            border: 0,
            borderBottom: `1px solid ${theme.palette.primary[100]}`,
          },
        }}>
        <Box
          sx={{
            maxHeight: "248px",
            overflowY: "auto",
            overflowX: "hidden",
            borderBottom: `1px solid ${theme.palette.primary[100]}`,
          }}>
          {workspaces?.map((workspace, index) => {
            return (
              <Menu.MenuItem
                key={workspace.name + index}
                selected={workspace.selected}
                onClick={workspace?.onWorkspaceClick}
                sx={{
                  alignItems: "flex-start",
                  py: 1.25,
                  whiteSpace: "normal",
                }}>
                <Box
                  sx={{
                    minWidth: 0,
                    width: "100%",
                  }}>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontWeight: 600,
                      lineHeight: 1.35,
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      overflowWrap: "anywhere",
                    }}>
                    {workspace.name}
                  </Typography>
                  <Typography
                    sx={{
                      color: "var(--mui-palette-text-secondary)",
                      fontSize: "11px",
                      fontWeight: 400,
                      lineHeight: 1.35,
                      mt: 0.25,
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      overflowWrap: "anywhere",
                    }}>
                    {workspace.description}
                  </Typography>
                </Box>
              </Menu.MenuItem>
            );
          })}
        </Box>
        <Menu.MenuItem sx={{ padding: 0 }} onClick={onAddWorkspaceClick}>
          <Button
            disableRipple
            variant="text"
            color="secondary"
            startIcon={<AddIcon />}
            fullWidth
            sx={{
              justifyContent: "flex-start",
              padding: "12px 16px",
              lineHeight: 1.35,
              height: "auto",
              fontSize: "12px",
            }}>
            Add Workspace
          </Button>
        </Menu.MenuItem>
      </Menu>
    </>
  );
};

export default WorkspaceMenu;
